import { render, staticRenderFns } from "./HomePageComponent.vue?vue&type=template&id=45a35bb6&scoped=true&"
import script from "./HomePageComponent.vue?vue&type=script&lang=js&"
export * from "./HomePageComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a35bb6",
  null
  
)

export default component.exports